import { useMemo } from "react";
import { Navigate } from "react-router";

import { LossType } from "@api/operations.generated";
import { useAppSelector } from "@redux/hooks";
import { selectLossType } from "@redux/slices";
import { StepPath } from "@routing/paths";

import { TheftOrVandalism } from "./TheftOrVandalism";
import { WeatherOrPropertyDamage } from "./WeatherOrPropertyDamage";
import { FireOrSmokeDamage } from "./FireOrSmokeDamage";
import { Other } from "./Other";
import { Liability } from "./Liability";
import { WaterDamage } from "./WaterDamage";

export function EnterClaimDetails() {
  const lossType = useAppSelector(selectLossType);

  return useMemo(() => {
    switch (lossType) {
      case LossType.TheftOrVandalism:
        return <TheftOrVandalism />;
      case LossType.FireOrSmokeDamage:
        return <FireOrSmokeDamage />;
      case LossType.WeatherOrPropertyDamage:
        return <WeatherOrPropertyDamage />;
      case LossType.WaterDamage:
        return <WaterDamage />;
      case LossType.Other:
        return <Other />;
      case LossType.Liability:
        return <Liability />;
      default:
        return <Navigate to={`/${StepPath.POLICY_DETAILS}`} />;
    }
  }, [lossType]);
}
